export default "__VITE_ASSET__Cnkz5GNg__";